module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/events/events-multiple-performance/events-multiple-performance.component.scss
// module id = ./src/app/routes/events/events-multiple-performance/events-multiple-performance.component.scss
// module chunks = 9